var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/133f07f20a6ed5d66ca0c01b7213de33.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4ca5ac986bd290e55f58a5acb232547d.js').default;
var scope_3 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/91dbd756fce0079a0e9df79384a6c720.js').default;
var scope_4 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ee48d29b9ac0d2f546b770209ea9680.js').default;
var scope_5 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a34bdd1a2bf09fe091c0494bcc797d1d.js').default;
var scope_6 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ae5ff5ae2cb77b4d1cd3a1aaa6ae1f59.js').default;
var scope_7 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d94bf113e32e1ca1226831a54c5a39f4.js').default;
var scope_8 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dddf990dbcbd7a4dedf1e76d78ae538a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    